import { mergeStyleSets } from "@fluentui/react";

export const useSourceListItem = () => {
  const classNames = mergeStyleSets({
    item: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px, 0px, 5px, 10px",
      WebkitTouchCallout: "none" /* iOS Safari */,
      WebkitUserSelect: "none" /* Safari */,
      KhtmlUserSelect: "none" /* Konqueror HTML */,
      MozUserSelect: "none" /* Old versions of Firefox */,
      MsUserSelect: "none" /* Internet Explorer/Edge */,
      UserSelect: "none" /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */,
    },
    icon: {
      paddingRight: "5px",
    },
    fontName: {
      fontFamily:
        "Segoe UI, Segoe UI Web (West European), -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif",
      display: "inline-block",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "100%",
    },
    attachment: {
      fontFamily:
        "Segoe UI, Segoe UI Web (West European), -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif",
      display: "inline-block",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "100%",
      cursor: "pointer",
    },
  });
  return {
    classNames,
  };
};
